export const getInitialState = function() {
	let defaults = {
		init       : false,
		listings : [],
		listingCount: null,
		totalPages: null,
		currentPage: 1,
		sortBy: null,
		mobileFiltersOpen: false,
		loading: true,
	};

	const urlParams = new URLSearchParams( window.location.search );
	let   filters   = {};
	
	for ( var pair of urlParams.entries() ) {
		filters[ pair[0] ] = pair[1]
	}

	defaults.filters = filters;

	return defaults;
}